import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Modal } from '@/components/ui/Modal'
import { updateRepairOrder } from '@/services/repairOrders.service'
import { toast } from '@/utils/helpers'

/**
 *
 * ResolveRepairOrderModal
 *
 */
const ResolveRepairOrderModal = ({
  isOpen,
  setIsOpen,
  repairOrder,
  repairOrderId,
  dealerId,
  onPendingPaymentReview,
}) => {
  const navigate = useNavigate()

  // State
  const [loading, setLoading] = useState(false)

  const handleError = (message) => toast(message, 'error')

  const writtenOffLineItems = repairOrder.lineItems.filter(
    (lineItem) => lineItem.state === 'Resolved - Written Off',
  )
  return (
    <Modal
      open={isOpen}
      title="Are You Sure?"
      setOpen={setIsOpen}
      loading={loading}
      content={
        <div className="mt-8">
          {writtenOffLineItems.length === 0 ? (
            <p className="text-gray mb-8 text-sm">No written off line items to confirm.</p>
          ) : (
            <>
              <p className="text-gray mb-8 text-sm">
                Please review the following write-off reasons and confirm that the Repair Order
                should be resolved.
              </p>
              <section className="ml-4">
                {writtenOffLineItems.map((lineItem) => (
                  <div className="mb-8">
                    <h3 className="mb-2 text-sm uppercase leading-3">{`Line Item ${lineItem.lineName}`}</h3>
                    <div className="ml-2 flex flex flex-col text-sm">
                      <div>
                        <span className="pr-2" aria-hidden="true">
                          •
                        </span>
                        <span className="pr-2">Department:</span>
                        <span>{lineItem.writeOffDepartment}</span>
                      </div>
                      <div>
                        <span className="pr-2" aria-hidden="true">
                          •
                        </span>
                        <span className="pr-2">Notes:</span>
                        <span>
                          {lineItem.writeOffNotes
                            ? lineItem.writeOffNotes
                            : 'No reasons reported.'}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </section>
            </>
          )}
        </div>
      }
      actions={[
        {
          type: 'submit',
          label: 'Resolve',
          onClick: async () => {
            const response = await updateRepairOrder(
              dealerId,
              repairOrderId,
              { markAsResolved: true },
              setLoading,
              handleError,
            )

            if (!response) return

            setIsOpen(false)

            if (response.pendingPaymentReview) {
              onPendingPaymentReview()
            } else {
              toast('Repair order has been resolved.', 'success')
              navigate(`/dealer/${dealerId}/detail`)
            }
          },
        },
        { type: 'cancel', label: 'Cancel' },
      ]}
    />
  )
}

export default ResolveRepairOrderModal

ResolveRepairOrderModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  repairOrder: PropTypes.object.isRequired,
  repairOrderId: PropTypes.string.isRequired,
  dealerId: PropTypes.string.isRequired,
  onPendingPaymentReview: PropTypes.func.isRequired,
}
